import React from 'react';

import './index.scss';

const getClassForEvent = (event) => {
  switch (event) {
    case 'PAUSED':
      return 'event__bubble_paused';
    case 'ACTIVE':
      return 'event__bubble_unpaused';
    case 'NEEDS_ATTENTION':
      return 'event__bubble_attention';
    case 'RESOLVED':
      return 'event__bubble_resolved';
    case 'ASSIGNMENT':
      return 'event__bubble_assignment';
    case 'OPT_OUT':
      return 'event__bubble_optout';
    default:
      return 'event__bubble_text';
  }
};
const getEventSuffix = (data, eventCreatedby) => {
  if (
    data.event === 'PAUSED' ||
    data.event === 'ACTIVE' ||
    data.event === 'RESOLVED'
  ) {
    return `by ${eventCreatedby}`;
  } else {
    if (data.nonNotification) {
      return data.eventDescription;
    } else {
      return `: "${data.eventDescription}"`;
    }
  }
};
const getAssignemnetData = (messageString) => {
  const messages = messageString.split(' ');
  return messages.slice(2, messages.length).join(' ');
};
const BubbleEvent = ({ data, eventCreatedby, record }) => {
  return (
    <div className="event">
      <div className="event__bubble">
        {data.event === 'ASSIGNMENT' ? (
          <div className={getClassForEvent(data.event)}>
            {data.nonNotification
              ? data.eventName
                .split(' ')
                .slice(0, 2)
                .join(' ')
              : 'Notification'}
          </div>
        ) : (
          <div className={getClassForEvent(data.event)}>
            {data.nonNotification ? data.eventName : 'Notification'}
          </div>
        )}
        {data.event !== 'OPT_OUT' && (
          <div className="event__bubble_suffix">
            {data.event === 'ASSIGNMENT'
              ? getAssignemnetData(data.eventDescription)
              : getEventSuffix(data, data.eventCreatedby)}
          </div>
        )}
      </div>
    </div>
  );
};

export default BubbleEvent;
